// extracted by mini-css-extract-plugin
module.exports = {"file-path":"style_file-path__2gyI-","file-path__pointer":"style_file-path__pointer__nxvp0","file-path__breadcrumb-arrow":"style_file-path__breadcrumb-arrow__1uwUh"};